export default "__VITE_ASSET__c28d3987__"